import { Button } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./PasswordResetSuccess.module.css";

interface PasswordresetSuccessProps {
  onBackToLoginClick: () => void;
}

const PasswordResetSuccess = (props: PasswordresetSuccessProps) => {
  const { t, m } = useTranslation();

  return (
    <div className={style.passwordResetSuccess}>
      <div className={style.modalContainer}>
        <Heading type="h1">{t(m.ResetPassword.PasswordUpdated)}</Heading>
        <div>
          <p className={style.message}>{t(m.ResetPassword.SuccessfulResetMessage)}</p>
        </div>
        <div>
          <Button className={style.backToLoginButton} onClick={props.onBackToLoginClick}>
            {t(m.ResetPassword.BackToLogin)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;
